<template>
<div class="empty-wrap">
  <div v-if="loading">
    <a-spin tip="正在加载" :spinning="loading" style="margin-top:60px" />
  </div>
  <div v-else>
    <img :src="imgSrc || require('@/assets/product/none.png')" :style="{ width: width + 'px' }" />
    <p :style="{ fontSize: fontSize + 'px' }">{{ text }}</p>
  </div>
</div>
</template>

<script>
export default {
  props: {
    // 缺省文案
    text: {
      type: String,
      default: "还没有数据库产品",
    },
    // 图片路径
    imgSrc: {
      type: String,
      default: "",
    },
    // 图片宽度
    width: {
      type: Number,
      default: 220,
    },
    // 字体大小
    fontSize: {
      type: Number,
      default: 14,
    },
    loading:{
      default:false
    }
  },
};
</script>

<style lang="scss">
.empty-wrap {
  display: flex;
  justify-content: center;
  align-items: center;

  p {
    margin-top: 13px;
    color: #777777;
    font-weight: 400;
    text-align: center;
  }
}
</style>
